/* eslint-disable @typescript-eslint/no-explicit-any */
import request from '../../../request/request';
import { log } from '../../../utils/notification';

export const getPostsFiltered = async (params) => {
  try {
    const response = await request<Request.Post, any>(true, 'POST', 'services/messenger/get-posts-filtered',  { params });

    return response;
  } catch (error) {
    log('getPostsFiltered', { response: error.message }, 'Error');
  }
};
